import axios from 'axios'

import { IsDev } from '../helpers/build'
import { withAbortingDuplicates } from '../helpers/cancelAction'
import {asyncTimeout} from '../helpers/utils'

const mockData = () => require('../mocks/rooms').default

export const GET_AUTOCOMPLETE_API = window?.drupalSettings?.widgets?.searchBoxKontoro?.api?.getAutocomplete;
export default async function (value) {
  if (IsDev) {
    console.info(`%c GET /autocomplete from mock data`, 'color: #67a9ad; font-weight: bold;')
    await asyncTimeout(1)
    return {data: mockData()}
  }
  return withAbortingDuplicates('autocomplete-hotel-rooms', signal => axios.get(GET_AUTOCOMPLETE_API, {
    signal,
    params: {
      q: encodeURIComponent(value),
    }
  }));
}
